import { type Control, Controller } from "react-hook-form";

import { Select2, SelectSkeleton } from "@/ui2/molecules/Select";
import { useCosignatureSupervisors } from "@/features/cosignature/api/queries/useCosignatureSupervisors";

import { CosignatureFormValues } from "../schema";

type AssignedSupervisorsSelectProps = {
  control: Control<CosignatureFormValues>;
};

export function AssignedSupervisorsSelect({ control }: AssignedSupervisorsSelectProps) {
  const { data: supervisors, isLoading } = useCosignatureSupervisors();

  if (isLoading) return <SelectSkeleton />;

  return (
    <Controller
      control={control}
      name="supervisorId"
      render={({ field }) => (
        <Select2
          label="Assigned Supervisor"
          onChange={field.onChange}
          options={supervisors}
          placeholder="Assigned Supervisor"
          value={field.value || null}
        />
      )}
    />
  );
}
